import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROSPECTS_PAGE_SIZE,
  ADMIN_PROSPECT_ACTIVITY_TYPES,
  ADMIN_PROSPECT_IMPORT_INPUT_MODES,
  ADMIN_PROSPECT_IMPORT_MAX_ROWS,
  ADMIN_PROSPECT_LOOKUP_TYPES,
  ADMIN_PROSPECT_STATUSES,
  CANADA_PROVINCE_CODES,
  buildAddAdminProspectNoteRequest,
  buildCommitAdminProspectImportRequest,
  buildCreateAdminProspectRequest,
  buildListAdminProspectActivitiesRequest,
  buildListAdminProspectImportHistoryRequest,
  buildListAdminProspectAssociatedCampaignsRequest,
  buildListAdminProspectsRequest,
  buildPreviewAdminProspectImportRequest,
  buildSuggestAdminProspectImportMappingRequest,
  buildUpdateAdminProspectRequest,
  buildPatchAdminProspectFollowUpRequest,
  buildUpdateAdminProspectPropertyDataRequest,
  buildCreateAdminProspectImportUploadRequest,
  buildParseAdminProspectImportFileRequest,
  buildConfirmAdminProspectImportMappingRequest,
  buildGetAdminProspectImportJobRequest,
  buildSetAdminProspectProjectionVerificationRequest,
} from './prospectsListRequest';
import {
  parseGetAdminProspect,
  parseListAdminProspectActivities,
  parseListAdminProspectImportHistory,
  parseListAdminProspectAssociatedCampaigns,
} from './prospectsResponse';
import {
  createAdminProspectImportUpload,
  parseAdminProspectImportFile,
  uploadProspectImportSource,
} from './prospectImportUpload';
import {
  ADMIN_PROSPECT_ANALYSIS_ADDRESS_PREFIX_MIN,
  ADMIN_PROSPECT_ANALYSIS_LINK_CANDIDATES_PAGE_SIZE,
  ADMIN_PROSPECT_ANALYSIS_OPTIONAL_TRANSFER_SECTIONS,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_ADDRESS,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_MUNICIPAL,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_OWNER_EXPENSES,
  buildCreateAdminProspectAnalysisPropertyRequest,
  buildLinkAdminProspectAnalysisPropertyRequest,
  buildListAdminProspectAnalysisLinkCandidatesRequest,
  buildProspectAnalysisCreatePreview,
  createAdminProspectAnalysisConversionWriteAttempt,
  fingerprintAdminProspectAnalysisConversionCreatePayload,
  fingerprintAdminProspectAnalysisConversionLinkPayload,
  generateAdminProspectAnalysisConversionOperationId,
  normalizeAdminProspectAnalysisTransferSelections,
} from './prospectAnalysisConversionRequest';

export {
  ADMIN_PROSPECTS_PAGE_SIZE,
  ADMIN_PROSPECT_ACTIVITY_TYPES,
  ADMIN_PROSPECT_IMPORT_INPUT_MODES,
  ADMIN_PROSPECT_IMPORT_MAX_ROWS,
  ADMIN_PROSPECT_LOOKUP_TYPES,
  ADMIN_PROSPECT_STATUSES,
  CANADA_PROVINCE_CODES,
  buildAddAdminProspectNoteRequest,
  buildCommitAdminProspectImportRequest,
  buildCreateAdminProspectRequest,
  buildListAdminProspectActivitiesRequest,
  buildListAdminProspectImportHistoryRequest,
  buildListAdminProspectAssociatedCampaignsRequest,
  buildListAdminProspectsRequest,
  buildPreviewAdminProspectImportRequest,
  buildSuggestAdminProspectImportMappingRequest,
  buildUpdateAdminProspectRequest,
  buildPatchAdminProspectFollowUpRequest,
  buildUpdateAdminProspectPropertyDataRequest,
  buildCreateAdminProspectImportUploadRequest,
  buildParseAdminProspectImportFileRequest,
  buildConfirmAdminProspectImportMappingRequest,
  buildGetAdminProspectImportJobRequest,
  buildSetAdminProspectProjectionVerificationRequest,
  createAdminProspectImportUpload,
  parseAdminProspectImportFile,
  uploadProspectImportSource,
  buildCreateAdminProspectAnalysisPropertyRequest,
  buildLinkAdminProspectAnalysisPropertyRequest,
  buildListAdminProspectAnalysisLinkCandidatesRequest,
  buildProspectAnalysisCreatePreview,
  createAdminProspectAnalysisConversionWriteAttempt,
  fingerprintAdminProspectAnalysisConversionCreatePayload,
  fingerprintAdminProspectAnalysisConversionLinkPayload,
  generateAdminProspectAnalysisConversionOperationId,
  normalizeAdminProspectAnalysisTransferSelections,
  ADMIN_PROSPECT_ANALYSIS_ADDRESS_PREFIX_MIN,
  ADMIN_PROSPECT_ANALYSIS_LINK_CANDIDATES_PAGE_SIZE,
  ADMIN_PROSPECT_ANALYSIS_OPTIONAL_TRANSFER_SECTIONS,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_ADDRESS,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_MUNICIPAL,
  ADMIN_PROSPECT_ANALYSIS_TRANSFER_SECTION_OWNER_EXPENSES,
};

export async function listAdminProspects(request) {
  const fn = httpsCallable(functions, 'listAdminProspects');
  const { data } = await fn(request);
  return data;
}

export async function createAdminProspect(payload) {
  const fn = httpsCallable(functions, 'createAdminProspect');
  const { data } = await fn(payload);
  return data;
}

export async function getAdminProspect(prospectId) {
  const fn = httpsCallable(functions, 'getAdminProspect');
  const { data } = await fn({ prospectId });
  return parseGetAdminProspect(data);
}

export async function updateAdminProspect(payload) {
  const fn = httpsCallable(functions, 'updateAdminProspect');
  const { data } = await fn(payload);
  return data;
}

export async function deleteAdminProspect(prospectId) {
  const fn = httpsCallable(functions, 'deleteAdminProspect');
  const { data } = await fn({ prospectId });
  return data;
}

export async function listAdminProspectActivities(request) {
  const fn = httpsCallable(functions, 'listAdminProspectActivities');
  const { data } = await fn(request);
  return parseListAdminProspectActivities(data);
}

export async function listAdminProspectImportHistory(request) {
  const fn = httpsCallable(functions, 'listAdminProspectImportHistory');
  const { data } = await fn(request);
  return parseListAdminProspectImportHistory(data);
}

export async function listAdminProspectAssociatedCampaigns(request) {
  const fn = httpsCallable(functions, 'listAdminProspectAssociatedCampaigns');
  const { data } = await fn(request);
  return parseListAdminProspectAssociatedCampaigns(data);
}

export async function addAdminProspectNote(payload) {
  const fn = httpsCallable(functions, 'addAdminProspectNote');
  const { data } = await fn(payload);
  return data;
}

export async function setAdminProspectProjectionVerification(payload) {
  const fn = httpsCallable(functions, 'setAdminProspectProjectionVerification');
  const { data } = await fn(payload);
  return data;
}

export async function updateAdminProspectPropertyData(payload) {
  const fn = httpsCallable(functions, 'updateAdminProspectPropertyData');
  const { data } = await fn(payload);
  return data;
}

export async function previewAdminProspectImport(payload) {
  const fn = httpsCallable(functions, 'previewAdminProspectImport');
  const { data } = await fn(payload);
  return data;
}

export async function commitAdminProspectImport(payload) {
  const fn = httpsCallable(functions, 'commitAdminProspectImport');
  const { data } = await fn(payload);
  return data;
}

export async function cancelAdminProspectImport(payload) {
  const fn = httpsCallable(functions, 'cancelAdminProspectImport');
  const { data } = await fn(payload);
  return data;
}

export async function suggestAdminProspectImportMapping(payload) {
  const fn = httpsCallable(functions, 'suggestAdminProspectImportMapping');
  const { data } = await fn(payload);
  return data;
}

export async function confirmAdminProspectImportMapping(payload) {
  const fn = httpsCallable(functions, 'confirmAdminProspectImportMapping');
  const { data } = await fn(payload);
  return data;
}

export async function getAdminProspectImportJob(payload) {
  const fn = httpsCallable(functions, 'getAdminProspectImportJob');
  const { data } = await fn(payload);
  return data;
}

export async function createAdminProspectAnalysisProperty(payload) {
  const fn = httpsCallable(functions, 'createAdminProspectAnalysisProperty');
  const { data } = await fn(payload);
  return data;
}

export async function linkAdminProspectAnalysisProperty(payload) {
  const fn = httpsCallable(functions, 'linkAdminProspectAnalysisProperty');
  const { data } = await fn(payload);
  return data;
}

export async function listAdminProspectAnalysisLinkCandidates(payload) {
  const fn = httpsCallable(functions, 'listAdminProspectAnalysisLinkCandidates');
  const { data } = await fn(payload);
  return data;
}

export async function previewAdminProspectAnalysisConversion(payload) {
  const fn = httpsCallable(functions, 'previewAdminProspectAnalysisConversion');
  const { data } = await fn(payload);
  return data;
}
